<template>
  <div class="pcb-product-card">
    <div class="pcb-product-card__image relative ratio ro-1">
      <vue-image
        v-if="product.images.length"
        :src="product.images[0]"
        :size="900"
        css="fit-contain"
        :alt="product.images_alt[0]"
      />
    </div>
    <div class="pcb-product-card__details">
      <yotpo-bottomline :id="product.id" :reviews-count="product.reviews_count" align="left"></yotpo-bottomline>
      <h4 class="h4 uppercase product-name" v-html="product.title"></h4>
      <p class="p1 product-size">
        <span v-if="!isSimpleProduct">{{ currentVariant.option1 }} — </span>
        <span>{{ currentVariant.price | formatPrice(true, 0) }}</span>
      </p>
      <pcb-qty-picker
        :quantity="quantity"
        :max="10"
        @change="handleQtyChange"
      />
      <button class="p2 underline" @click="toggleDrawer">View Details</button>
    </div>
    <content-drawer
      :title="product.title"
      :id="product.handle"
      ref="container"
    >
      <v-runtime-template :template="product.drawer_content"></v-runtime-template>
    </content-drawer>
  </div>
</template>

<script>
import 'modules/image/image.vue'
import 'modules/yotpo-bottomline/yotpo-bottomline.vue'
import 'modules/content-drawer/content-drawer.vue'
import PcbQtyPicker from 'modules/pcb-qty-picker/pcb-qty-picker.vue'
import state from 'lib/appState'
import Vue from 'vue'
import VRuntimeTemplate from "v-runtime-template"
import bus from 'lib/bus'

export default {
  props: [
    'product',
    'quantity',
    'addToBundle'
  ],
  components: {
    VRuntimeTemplate,
    PcbQtyPicker
  },
  data () {
    return {
      state
    }
  },
  computed: {
    currentVariant () {
      return this.product.variants[0]
    },
    firstOption () {
      return (this.product.options || [])[0]
    },
    isSimpleProduct () {
      return this.firstOption === 'Title'
    }
  },
  methods: {
    toggleDrawer () {
      this.state.activeDrawer = this.product.handle
      this.state.modalToggleEl = document.activeElement
    },
    handleQtyChange (value) {
      this.$emit('add-to-bundle', this.product)
      bus.$emit('custom_bundle/ADD_TO_BUNDLE', { product: this.product, quantity: value })
    }
  }
}
</script>
